import { firebase, db, auth } from '../firebase'
import isEmpty from 'ramda/src/isEmpty'
import router from '../router/index'

const actions = {
  // asynchronous
  async login(store) {
    if (store.state.loggedIn) return

    const provider = new firebase.auth.GoogleAuthProvider()
    try {
      await auth.signInWithPopup(provider)
      store.state.currentTab = 'tab1'
    } catch (error) {
      console.log(error)
    }
  },

  async logout(store) {
    try {
      await auth.signOut()
      store.state.loggedIn = false
      router.push('/')
    } catch (error) {
      console.log(error)
    }
  },

  setLog({ state, commit }, { logId, log }) {
    log.userId = state.user.id
    db.collection('logs')
      .doc(logId)
      .set(log)
      .then(() => {
        console.log('Log set!')
      })
      .catch(error => {
        console.error('Error writing document:', error)
      })

    log.id = logId
    const filteredLogs = state.logs.filter(stateLog => stateLog.id !== logId)
    commit('SET_LOGS', [...filteredLogs, log])
  },

  createHabit({ state, commit }, { habitId, habit }) {
    const existingCategory = state.habits.filter(
      stateHabit => stateHabit.category === habit.category
    )
    habit.subIndex = existingCategory ? existingCategory.length : 0
    habit.allIndex = state.habits.length

    db.collection('habits')
      .doc(habitId)
      .set(habit)
      .then(() => {
        console.log('Habit set!')
      })
      .catch(error => {
        console.error('Error writing document:', error)
      })

    habit.id = habitId
    commit('SET_HABITS', [...state.habits, habit])
  },

  updateHabit({ state, commit }, { habitId, habit }) {
    db.collection('habits')
      .doc(habitId)
      .set(habit)
      .then(() => {
        console.log('Habit set!')
      })
      .catch(error => {
        console.error('Error writing document:', error)
      })
  },

  updateReorderedHabits({ state, commit }, { habits }) {
    habits.forEach(habit => {
      db.collection('habits')
        .doc(habit.id)
        .set(habit)
        .catch(error => {
          console.error('Error writing document:', error)
        })
    })
  },

  deleteHabit({ state, commit }, { habitId, category }) {
    db.collection('habits')
      .doc(habitId)
      .delete()
      .then(() => {
        console.log(habitId + ' deleted!')
      })
      .catch(error => {
        console.error('Error deleting habit:', error)
      })

    db.collection('logs')
      .where('userId', '==', state.user.id)
      .where('habitId', '==', habitId)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          doc.ref.delete().then(() => {
            console.log(`${doc.ref} log with ${habitId} deleted!`)
          })
        })
      })
      .catch(error => {
        console.error('Error deleting log:', error)
      })

    const logs = state.logs.filter(log => log.habitId !== habitId)
    commit('SET_LOGS', logs)

    const habits = state.habits
    if (!isEmpty(habits)) {
      const categoryIsUsed = habits.some(habit => habit.category === category)
      if (!categoryIsUsed) {
        state.categories.delete(category)
      }
    }
  }
}

export default actions
